<ion-grid class="application-list-ion-grid">
    <ion-row>
        <ion-col size="12">
            <div class="list application-list-parent">
                <!-- ***************************************** DESKTOP APPLICATION LIST *****************************************-->
                <div class="desktop-application-list">
                    <ion-row class="list-title-row">
                        <ion-col size="2" class="ion-text-center"> </ion-col>
                        <ion-col size="2" class="ion-text-left">
                            <p>Dates</p>
                        </ion-col>
                        <ion-col size="4">
                            <p>Application</p>
                        </ion-col>
                        <ion-col size="2" class="ion-text-center">
                            <p>Status</p>
                        </ion-col>
                        <ion-col size="2">
                            <p>Next steps</p>
                        </ion-col>
                    </ion-row>
                    <ion-row
                        *ngFor="let application of applications"
                        (click)="applicationRouting(application)"
                        (contextmenu)="open($event, application)"
                        class="desktop-application-item"
                        (mouseenter)="hoverField.style.display = 'block'"
                        (mouseleave)="hoverField.style.display = 'none'"
                    >
                        <ion-col size="2" class="ion-text-center">
                            <div class="pcard-image">
                                <picture>
                                    <source
                                        *ngFor="let image of application.srcSetImages"
                                        media="{{ image.media }}"
                                        type="{{ image.type }}"
                                        srcset="{{image.srcSet}}"
                                    />
                                    <source srcset="{{application?.imagestate}}" type="image/jpg" />
                                    <img src="{{ application?.imagestate }}" />
                                </picture>
                            </div>
                        </ion-col>
                        <ion-col size="2">
                            <div>
                                <ion-text class="date-start-end">
                                    <p class="dashboard-text">
                                        {{ application?.startdate | date : 'longDate' : 'UTC' }}
                                        -
                                    </p>
                                    <p class="dashboard-text">
                                        {{ application?.enddate | date : 'longDate' : 'UTC' }}
                                    </p>
                                </ion-text>
                            </div>
                        </ion-col>
                        <ion-col size="4">
                            <ion-text class="ion-text-wrap bold-text">
                                {{ application?.name }}
                            </ion-text>
                            <div>
                                <ion-text>
                                    <small class="application-location-text">{{ application?.count }} Clinical Experiences </small>
                                </ion-text>
                            </div>
                            <div class="application-type-col-box">
                                <small>{{ application?.type }}</small>
                                <ion-badge *ngIf="application?.switchprotectionpaid" class="badge-switch-protection">
                                    <ion-icon class="icon-switch-protection" name="star"></ion-icon>
                                    Switch Protection</ion-badge
                                >
                            </div>
                        </ion-col>
                        <ion-col size="2" class="ion-text-center">
                            <div>
                                <!-- <amo-status-indicator-tag></amo-status-indicator-tag> -->
                                <ion-chip color="primary" mode="md" fill="clear">
                                    <ion-label class="dashboard-text"
                                        >{{ application?.states === 'Pending-Booked' ? 'Pending' : application?.states }}
                                    </ion-label>
                                </ion-chip>
                            </div>
                        </ion-col>
                        <ion-col size="2" class="hover-text-wrapper">
                            <div style="margin-top: 0.5em">
                                <ion-text class="future-status-label">
                                    <p class="dashboard-text">
                                        {{ application | futureStatus }}
                                        <fa-icon [icon]="faAngleRight"></fa-icon>
                                    </p>
                                </ion-text>
                            </div>
                            <div class="hover-text" #hoverField [hidden]="application?.states === 'Completed'">
                                <div class="popover-arrow popover-arrow-tc"></div>
                                <p>
                                    <label>
                                        {{ getPopoverMsg(application) }}
                                    </label>
                                </p>
                            </div>
                        </ion-col>
                    </ion-row>

                    <ion-row *ngIf="chainApplications?.length">
                        <ion-col size="12">
                            <mat-accordion *ngFor="let applicationParent of chainApplications; let i = index">
                                <mat-expansion-panel hideToggle class="mat-exp-panel" (contextmenu)="open($event, applicationParent)">
                                    <mat-expansion-panel-header #panelH (click)="panelH._toggle()">
                                        <mat-panel-title>
                                            <ion-col size="3">
                                                <div>
                                                    <ion-text>
                                                        <p class="dashboard-text">
                                                            {{ (applicationParent?.applications)[0]?.startdate | date : 'longDate' : 'UTC' }}
                                                            -
                                                            {{
                                                                (applicationParent?.applications)[applicationParent?.applications.length - 1]?.enddate
                                                                    | date : 'longDate' : 'UTC'
                                                            }}
                                                        </p>
                                                    </ion-text>
                                                </div>
                                            </ion-col>
                                            <ion-col size="1" style="display: flex; justify-content: center; align-items: center" class="ion-text-center">
                                                <button class="open-toggle-btn" (click)="panelH._toggle(); openChainList(i)">
                                                    <fa-icon
                                                        class="detail-arrow"
                                                        [ngClass]="{
                                                            'reset-arrow': !firstClick[i]
                                                        }"
                                                        [icon]="faChevronDown"
                                                    ></fa-icon>
                                                </button>
                                            </ion-col>
                                            <ion-col size="4">
                                                <ion-text class="ion-text-wrap bold-text">
                                                    {{ applicationParent?.name }}
                                                </ion-text>
                                                <div>
                                                    <ion-text>
                                                        <small class="application-location-text"
                                                            >{{ applicationParent?.count }}
                                                            Clinical Experiences
                                                        </small>
                                                    </ion-text>
                                                </div>
                                                <div>
                                                    <small>{{ applicationParent?.type }}</small>
                                                </div>
                                            </ion-col>
                                            <ion-col size="2">
                                                <div class="ion-text-center">
                                                    <!-- <amo-status-indicator-tag></amo-status-indicator-tag> -->
                                                    <ion-chip color="primary" mode="md" fill="clear">
                                                        <ion-label class="dashboard-text">In Progress</ion-label>
                                                    </ion-chip>
                                                </div>
                                            </ion-col>
                                            <ion-col size="2">
                                                <div style="margin-top: 0.5em; text-align: center" (click)="applicationChainRouting(applicationParent)">
                                                    <ion-text class="teal-text">
                                                        <p class="dashboard-text">
                                                            Next Steps<fa-icon class="next-step-arrow" [icon]="faAngleRight"></fa-icon>
                                                        </p>
                                                    </ion-text>
                                                </div>
                                            </ion-col>
                                        </mat-panel-title>
                                    </mat-expansion-panel-header>
                                    <div>
                                        <ion-row
                                            *ngFor="let application of applicationParent.applications"
                                            (click)="applicationChainRouting(applicationParent)"
                                            (contextmenu)="open($event, application)"
                                            class="desktop-application-item"
                                        >
                                            <ion-col size="2" class="ion-text-center">
                                                <div class="pcard-image">
                                                    <picture>
                                                        <source
                                                            *ngFor="let image of application.srcSetImages"
                                                            media="{{ image.media }}"
                                                            type="{{ image.type }}"
                                                            srcset="{{image.srcSet}}"
                                                        />
                                                        <source srcset="{{application?.imagestate}}" type="image/jpg" />
                                                        <img src="{{ application?.imagestate }}" />
                                                    </picture>
                                                </div>
                                            </ion-col>
                                            <ion-col size="2">
                                                <div>
                                                    <ion-text>
                                                        <p class="dashboard-text">
                                                            {{ application?.startdate | date : 'longDate' : 'UTC' }}
                                                            -
                                                            {{ application?.enddate | date : 'longDate' : 'UTC' }}
                                                        </p>
                                                    </ion-text>
                                                </div>
                                            </ion-col>
                                            <ion-col size="4">
                                                <ion-text class="ion-text-wrap bold-text">
                                                    {{ application?.name }}
                                                </ion-text>
                                                <div>
                                                    <ion-text>
                                                        <small class="application-location-text">{{ application?.count }} Clinical Experiences </small>
                                                    </ion-text>
                                                </div>
                                                <div class="application-type-col-box">
                                                    <small>{{ application?.type }}</small>
                                                    <ion-badge *ngIf="application?.switchprotectionpaid" class="badge-switch-protection">
                                                        <ion-icon class="icon-switch-protection" name="star"></ion-icon>
                                                        Switch Protection</ion-badge
                                                    >
                                                </div>
                                            </ion-col>
                                            <ion-col size="2" class="ion-text-center">
                                                <div>
                                                    <!-- <amo-status-indicator-tag></amo-status-indicator-tag> -->
                                                    <ion-chip color="primary" mode="md" fill="clear">
                                                        <ion-label class="dashboard-text">
                                                            {{ application?.states === 'Pending-Booked' ? 'Pending' : application?.states }}
                                                        </ion-label>
                                                    </ion-chip>
                                                </div>
                                            </ion-col>
                                            <ion-col size="2">
                                                <div style="margin-top: 0.5em">
                                                    <ion-text class="future-status-label">
                                                        <p class="dashboard-text">
                                                            {{ application | futureStatus }}
                                                            <fa-icon [icon]="faAngleRight"></fa-icon>
                                                        </p>
                                                    </ion-text>
                                                </div>
                                            </ion-col>
                                        </ion-row>
                                    </div>
                                </mat-expansion-panel>
                                <!-- <mat-expansion-panel (opened)="panelOpenState = true"
                                                     (closed)="panelOpenState = false">
                                  <mat-expansion-panel-header>
                                    <mat-panel-title>
                                      Self aware panel
                                    </mat-panel-title>
                                    <mat-panel-description>
                                      Currently I am {{panelOpenState ? 'open' : 'closed'}}
                                    </mat-panel-description>
                                  </mat-expansion-panel-header>
                                  <p>I'm visible because I am open</p>
                                </mat-expansion-panel> -->
                            </mat-accordion>
                        </ion-col>
                    </ion-row>
                    <!-- Template for right click menu -->
                    <ng-template #navMenu let-selectedTab>
                        <section>
                            <ion-item class="context-menu" button (click)="openNewTab(selectedTab)">
                                <ion-label>Open in new tab</ion-label>
                            </ion-item>
                        </section>
                    </ng-template>
                </div>
                <!-- ***************************************** MOBILE APPLICATION LIST *****************************************-->
                <div class="mobile-application-list">
                    <ion-item
                        *ngFor="let application of applications"
                        (click)="applicationRouting(application)"
                        button
                        detail="false"
                        class="application-list-item"
                    >
                        <ion-badge slot="end" *ngIf="application?.switchprotectionpaid" class="badge-switch-protection">
                            <ion-icon class="icon-switch-protection" name="star"></ion-icon>
                            Switch Protection</ion-badge
                        >
                        <ion-label>
                            <ion-text class="ion-text-wrap">
                                <ion-card-title>{{ application?.name }}</ion-card-title>
                            </ion-text>
                            <div class="card-subtitle">
                                {{ application?.city }}, {{ application?.state }} |
                                {{ application?.type }}
                                <br />
                                {{ application?.startdate | date : 'longDate' : 'UTC' }}
                                -
                                {{ application?.enddate | date : 'longDate' : 'UTC' }}
                                <div class="mobile-application-container">
                                    <div class="mobile-application-text">
                                        <ion-text class="ion-text-uppercase">
                                            <p class="application-status-title">Application Status:</p>
                                        </ion-text>
                                        <ion-text color="primary">
                                            <small class="application-status-output">{{
                                                application?.states === 'Pending-Booked' ? 'Pending' : application?.states
                                            }}</small>
                                        </ion-text>
                                    </div>
                                    <div class="mobile-application-text next-step-container">
                                        <ion-text class="ion-text-uppercase">
                                            <p class="application-status-title">Next Steps:</p>
                                        </ion-text>
                                        <ion-text class="future-status-label ion-text-wrap">
                                            <small class="application-status-output">
                                                {{ application | futureStatus }}
                                                <fa-icon [icon]="faAngleRight"></fa-icon>
                                            </small>
                                        </ion-text>
                                    </div>
                                </div>
                            </div>
                        </ion-label>
                    </ion-item>
                    <div *ngIf="chainApplications?.length">
                        <div *ngFor="let applicationParent of chainApplications; let i = index" class="application-list-item">
                            <mat-expansion-panel hideToggle class="mat-exp-panel" (contextmenu)="open($event, applicationParent)">
                                <mat-expansion-panel-header #panelH (click)="panelH._toggle()">
                                    <mat-panel-title>
                                        <div (click)="applicationChainRouting(applicationParent)" class="mobile-chain-label">
                                            <ion-label>
                                                <ion-text class="ion-text-wrap">
                                                    <ion-card-title>
                                                        {{ applicationParent?.name }}
                                                    </ion-card-title>
                                                </ion-text>
                                                <div>
                                                    <ion-text>
                                                        <small class="application-location-text"
                                                            >{{ applicationParent?.count }}
                                                            Clinical Experiences
                                                        </small>
                                                    </ion-text>
                                                </div>
                                                <div>
                                                    <small>{{ applicationParent?.type }}</small>
                                                </div>
                                                <div class="card-subtitle">
                                                    <ion-text>
                                                        {{ (applicationParent?.applications)[0]?.startdate | date : 'longDate' : 'UTC' }}
                                                        -
                                                        {{
                                                            (applicationParent?.applications)[applicationParent?.applications.length - 1]?.enddate
                                                                | date : 'longDate' : 'UTC'
                                                        }}
                                                    </ion-text>
                                                </div>
                                            </ion-label>
                                        </div>
                                        <div (click)="applicationChainRouting(applicationParent)" class="mobile-application-text next-step-chain-container">
                                            <div>
                                                <ion-text class="ion-text-uppercase">
                                                    <p class="application-status-chain-title">Next Steps:</p>
                                                </ion-text>

                                                <ion-text class="future-status-label ion-text-wrap">
                                                    <small class="application-status-chain-output">
                                                        View Applications
                                                        <fa-icon [icon]="faAngleRight"></fa-icon>
                                                    </small>
                                                </ion-text>
                                            </div>
                                        </div>
                                        <div class="mobile-chain-button">
                                            <button class="open-toggle-btn" (click)="panelH._toggle(); openChainList(i)">
                                                <fa-icon
                                                    class="detail-arrow"
                                                    [ngClass]="{
                                                        'reset-arrow': !firstClick[i]
                                                    }"
                                                    [icon]="faChevronDown"
                                                ></fa-icon>
                                            </button>
                                        </div>
                                    </mat-panel-title>
                                </mat-expansion-panel-header>
                                <div>
                                    <ion-item
                                        *ngFor="let application of applicationParent.applications"
                                        (click)="applicationRouting(application)"
                                        button
                                        detail="false"
                                        class="application-list-item"
                                    >
                                        <ion-badge slot="end" *ngIf="application?.switchprotectionpaid" class="badge-switch-protection">
                                            <ion-icon class="icon-switch-protection" name="star"></ion-icon>
                                            Switch Protection</ion-badge
                                        >
                                        <ion-label>
                                            <ion-text class="ion-text-wrap">
                                                <ion-card-title>{{ application?.name }}</ion-card-title>
                                            </ion-text>
                                            <div class="card-subtitle">
                                                {{ application?.city }}, {{ application?.state }} |
                                                {{ application?.type }}
                                                <br />
                                                {{ application?.startdate | date : 'longDate' : 'UTC' }}
                                                -
                                                {{ application?.enddate | date : 'longDate' : 'UTC' }}
                                                <div class="mobile-application-container">
                                                    <div class="mobile-application-text">
                                                        <ion-text class="ion-text-uppercase">
                                                            <p class="application-status-title mobile-chain-status">Application Status:</p>
                                                        </ion-text>
                                                        <ion-text color="primary">
                                                            <small class="application-status-output">{{
                                                                application?.states === 'Pending-Booked' ? 'Pending' : application?.states
                                                            }}</small>
                                                        </ion-text>
                                                    </div>
                                                    <div class="mobile-application-text next-step-container">
                                                        <ion-text class="ion-text-uppercase">
                                                            <p class="application-status-title mobile-chain-status">Next Steps:</p>
                                                        </ion-text>
                                                        <ion-text class="future-status-label ion-text-wrap">
                                                            <small class="application-status-output">
                                                                {{ application | futureStatus }}
                                                                <fa-icon [icon]="faAngleRight"></fa-icon>
                                                            </small>
                                                        </ion-text>
                                                    </div>
                                                </div>
                                            </div>
                                        </ion-label>
                                    </ion-item>
                                </div>
                            </mat-expansion-panel>
                        </div>
                    </div>
                </div>
            </div>
        </ion-col>
    </ion-row>
</ion-grid>
